import { ThemeText, Text, View } from "@/components/Theme";
import { text } from "@/constants/Styles";
import isEqual from "lodash/isEqual";
import { memo, useMemo } from "react";
import { StyleSheet } from "react-native";

const ListItemText = (props) => {

    const {
        pretitle = null,
        title = null,
        subtitle = null,
        children = null,
        pretitleProps = {},
        titleProps = {},
        subtitleProps = {},
        themed = true,
        ...rest
    } = props;

    const preTitleStyle = useMemo(() => {
        const base = [];

        if (pretitleProps?.variant == null) {
            base.push(text.small);
        }

        base.push(styles.pretitle);
        
        if (pretitleProps?.style != null) {
            base.push(pretitleProps.style);
        }

        return StyleSheet.flatten(base);
    }, [styles.pretitle, pretitleProps]);

    const titleStyle = useMemo(() => {
        const base = [];

        if (titleProps?.variant == null) {
            base.push(text.h2);
        }
        
        base.push(styles.title);
        
        if (titleProps?.style != null) {
            base.push(titleProps.style);
        }

        return StyleSheet.flatten(base);
    }, [styles.pretitle, titleProps]);

    const subTitleStyle = useMemo(() => {
        const base = [];
        
        if (subtitleProps?.variant == null) {
            base.push(text.small);
        }

        base.push(styles.subtitle);
        
        if (subtitleProps?.style != null) {
            base.push(subtitleProps.style);
        }

        return StyleSheet.flatten(base);
    }, [styles.pretitle, subtitleProps]);

    if (children != null && title == null) {
        return (
            <View style={{flex: 1}}>
                {children}
            </View>
        );
    }
    
    const TextComp = themed ? ThemeText : Text;

    return (
        <View style={styles.rightItem}>
            {pretitle != null && <TextComp {...pretitleProps} style={preTitleStyle} {...rest} id={pretitle} />}
            {title != null && <TextComp {...titleProps} style={titleStyle} {...rest} id={title} />}
            {subtitle != null && <TextComp {...subtitleProps} style={subTitleStyle} {...rest} id={subtitle} />}
            {children}
        </View>
    );
};

const styles = StyleSheet.create({
    
    
    pretitle: {},
    title: {
        borderWidth: 0.1,
        borderColor: 'transparent',
    },
    subtitle: {},
    rightItem: {
        flex: 1,
        flexDirection: 'column',
    }
});

export default memo(ListItemText, isEqual);